import { ConfigurationInsurersModalState, initialConfigurationInsurersModalState } from '@/modules/configurationModule/detail/cases/insurers/components/modal-basic-form/insurers-modal-basic-form.model'
import { ConfigurationInsurerCreateRequest, ConfigurationInsurerPatchInBatchRequest, ConfigurationInsurerResponse } from '@/modules/configurationModule/detail/cases/insurers/services/configuration-insurer.dto'
import { Nullable } from '@/shared/types/app.types'
import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class InsurersModalBasicForm extends Vue {
    @Ref() readonly insurersModal!: any
    @Prop(String) readonly actionTitle!: string

    state: ConfigurationInsurersModalState
    constructor() {
        super()
        this.state = initialConfigurationInsurersModalState()
    }

    @Emit()
    create(): ConfigurationInsurerCreateRequest {
        return {
            name: this.state.name,
            code: this.state.code,
            email: this.state.email,
            sendAuthorizations: this.state.sendAuthorizations,
            active: this.state.active
        }
    }

    @Emit()
    update(): ConfigurationInsurerPatchInBatchRequest {
        return {
            id: this.state.id ?? 0,
            name: this.state.name,
            code: this.state.code,
            email: this.state.email,
            sendAuthorizations: this.state.sendAuthorizations,
            active: this.state.active
        }
    }

    get mandatoryEmailCharacter(): string {
        return (this.state.sendAuthorizations ? '*' : '')
    }

    async show(selectedRow: Nullable<ConfigurationInsurerResponse>): Promise<void> {
        await this.initializeInsurer(selectedRow)
        this._showModal()
    }

    private _showModal(): void {
        this.insurersModal.show()
    }

    async initializeInsurer(insurer: Nullable<ConfigurationInsurerResponse>): Promise<void> {
        this.state = initialConfigurationInsurersModalState()
        await this.$validator.reset()
        if (insurer) {
            this.state = {
                id: insurer.id,
                name: insurer.name,
                code: insurer.code,
                email: insurer.email,
                sendAuthorizations: insurer.sendAuthorizations,
                system: insurer.system,
                active: insurer.active
            }
        }
    }

    get updateMode(): boolean {
        return !!this.state.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    get emailValidation(): string {
        return this.state.sendAuthorizations ? 'required|email' : 'email'
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update()
            } else {
                this.create()
            }
            this.hide()
        }
    }

    hide(): void {
        this.insurersModal.hide()
    }
}
